export default __webpack_public_path__ + "static/media/img-slider-scb-anywhere-1.03ac621e.png";